/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Components
import TemplateModules from 'ui/components/TemplateModules.vue';
import ModalShowcase from 'ui/components/modals/Showcase.vue';

/**
 * This component is used to show more details of a specific template.
 *
 * If this template has images/screenshots, they will be displayed in a carousel
 * If this template has a long description, it will be displayed on a description section bellow the carousel
 *
 * @category ui.components
 * @exports TemplateDetails
 */
const __vue_script__ = {
    name: 'TemplateDetails',

    components: { TemplateModules, ModalShowcase },

    props: {
        templateId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            loading: true,
            media: null,
            template: {
                packages: []
            },
            name: '',
        };
    },

    async created() {
        try {
            const { template } = await this.$services.template.getTemplateDetails(this.templateId, true);

            this.template = template;
            this.media = this.template.images.filter(m => m !== null);
            this.name = this.$utils.workspaces.getWorkspaceTitle(template, this.$i18n.locale);

        } catch (error) {
            console.error('[TemplateDetails] An error occurred while loading template details');
            this.$services.crashReporting.captureException(error);
        } finally {
            this.loading = false;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-showcase',{attrs:{"media":_vm.media,"close":function () { return _vm.$emit('close'); },"loading":_vm.loading},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h1',[_vm._v(_vm._s(_vm.name))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.template.template_description))])]},proxy:true},{key:"main_details",fn:function(){return [_c('header',[_c('h4',[_vm._v(_vm._s(_vm.$t('general.description')))])]),_c('div',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.template.template_long_description || _vm.$t('general.no_description'))}})]},proxy:true},{key:"side_details",fn:function(){return [_c('div',{staticClass:"installed-modules"},[_c('header',[_c('h4',[_vm._v(_vm._s(_vm.$t('marketplace.package.modules')))])]),(_vm.template.packages.length)?_c('template-modules',{attrs:{"packages":_vm.template.packages}}):_vm._e()],1)]},proxy:true}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "TemplateDetails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__